// SocialShare.jsx
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  FacebookIcon,
  WhatsappIcon,
  XIcon  
} from "react-share";



export default function SocialShare({mobile}) {
                   const [url, setUrl] = useState("");
                
                  const location = useLocation();

                  useEffect(() => {
                    setUrl(window.location.href);
                  }, [location.pathname]);


      if (!url) return null; 


  return (
    <div className={mobile ? "social-share-section mobile-share" : "social-share-section desktop-share"}>

     {/* <span className="share-title"> share: </span> */}
     
      <FacebookShareButton url={url} className="share-icon" aria-label="Share on Facebook">
     <FacebookIcon size={32} round />
     </FacebookShareButton>

     <WhatsappShareButton url={url} className="share-icon"  aria-label="Share on WhatsApp">
     <WhatsappIcon size={32} round />
     </WhatsappShareButton>

    <TwitterShareButton url={url} className="share-icon" aria-label="Share on X (Twitter)">
    <XIcon size={32} round />
     </TwitterShareButton>
    </div>
  );
}